<script setup lang="ts">
import { computed } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { useComponentComposable } from '@/components/useComponentComposable';
import Checkbox from 'primevue/checkbox';

interface Props {
  listDayOfWeek: number[];
  checkAvailableDate: boolean;
}
const props = defineProps<Props>();

const currentLanguage = getCurrentLocale();
const { getFirstCharacterOfDay } = useComponentComposable();

const days = computed(() => getFirstCharacterOfDay(currentLanguage));

const dayOfWeek = computed(() => {
  return renderData(props.listDayOfWeek);
});

const renderData = (listDay: number[] | null) => {
  if (listDay) {
    return days.value.map((day: string, index: number) => {
      return {
        label: day,
        value: !!listDay[index]
      };
    });
  } else {
    return [];
  }
};
</script>

<template>
  <div class="select-dates w-full">
    <div class="flex gap-1 justify-content-between seasonal-list-display" v-if="checkAvailableDate">
      <div v-for="(day, index) of dayOfWeek" :key="index" class="flex align-items-center">
        <Checkbox class="seasonal_day mt-1" :disabled="true" :inputId="'input-' + index" :binary="true" v-model="day.value" />
        <label class="mb-0 font-bold" :for="'input-' + index">
          {{ day.label }}
        </label>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.select-dates {
  :deep() {
    .p-checkbox .p-checkbox-box.p-highlight {
      border-color: #6366f1;
      background: #6366f1;
    }
    .p-checkbox .p-checkbox-box {
      width: 18px;
      height: 18px;
      border-radius: 5px;
    }
  }
}
</style>
